import { Component } from 'react';
import ProjectPiece, { Project } from './projectPiece';
import { Fade } from 'react-awesome-reveal';

interface ProjectsState {
    projectPieces: Project[];
    currentFilter: string;
}

class Projects extends Component<Record<string, never>, ProjectsState> {
    state: ProjectsState = {
        projectPieces: [
            {
                image: '/assets/images/portfolio/fundastand.jpg',
                filters: ['Vue', 'Javascript'],
                name: 'Fundastand',
                link: 'http://fundastand.adearlife.com',
            },
            {
                image: '/assets/images/portfolio/adearlife.jpg',
                filters: ['React', 'Javascript'],
                name: 'A Dear Life',
                link: 'http://adearlife.com',
            },
            {
                image: '/assets/images/portfolio/greatdogescape.jpg',
                filters: ['HTML'],
                name: 'Great dog escape',
                link: 'http://greatdogescape.com',
            },
            {
                image: '/assets/images/portfolio/sass-loaders.png',
                filters: ['HTML'],
                name: 'SASS Loaders',
                link: 'http://andrewdear.github.io/SassLoaders/index.html',
            },
        ],
        currentFilter: 'All',
    };

    renderFilterButtons() {
        const filters: string[] = [];
        this.state.projectPieces.forEach((piece) => {
            piece.filters.forEach((filter) => {
                if (filters.indexOf(filter) < 0) filters.push(filter);
            });
        });
        filters.unshift('All');
        return filters.map((filter) => (
            <div
                className={`projectFilterButton ${this.state.currentFilter === filter ? 'current' : ''}`}
                key={filter}
                onClick={() => this.setState({ currentFilter: filter })}
            >
                {filter}
            </div>
        ));
    }

    projectsToShow(): Project[] {
        if (this.state.currentFilter === 'All') return this.state.projectPieces;
        return this.state.projectPieces.filter((project) =>
            project.filters.indexOf(this.state.currentFilter) >= 0
        );
    }

    render() {
        return (
            <div className='projects'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <Fade>
                                <h2>Personal Projects</h2>
                            </Fade>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12 filters'>
                            <Fade>
                                <div>{this.renderFilterButtons()}</div>
                            </Fade>
                        </div>
                    </div>
                    <Fade>
                        <div className='row gallery'>
                            {this.projectsToShow().map((piece, index) => (
                                <ProjectPiece key={index} piece={piece} />
                            ))}
                        </div>
                    </Fade>
                </div>
            </div>
        );
    }
}

export default Projects;
